import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import Visibility from '../Visibility';
import styles from './carousel.css';
import useMedia from '../../lib/hooks/useMedia';
import easeInOutQuad from '../../lib/easeInOutQuad';
import useDimensions from '../../lib/hooks/useDimensions';
var cx = classnames.bind(styles);
export default function Carousel(_ref) {
  var children = _ref.children,
      className = _ref.className,
      cycle = _ref.cycle,
      fluid = _ref.fluid,
      inverted = _ref.inverted,
      onAutoScroll = _ref.onAutoScroll,
      onUserScroll = _ref.onUserScroll,
      padded = _ref.padded,
      scrollable = _ref.scrollable,
      scrollDuration = _ref.scrollDuration,
      scrollInterval = _ref.scrollInterval,
      stickyOffset = _ref.stickyOffset,
      indicator = _ref.indicator,
      onTop = _ref.onTop,
      step = _ref.step,
      other = _objectWithoutProperties(_ref, ["children", "className", "cycle", "fluid", "inverted", "onAutoScroll", "onUserScroll", "padded", "scrollable", "scrollDuration", "scrollInterval", "stickyOffset", "indicator", "onTop", "step"]);

  var items = {};

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      canScrollLeft = _useState4[0],
      setCanScrollLeft = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      canScrollRight = _useState6[0],
      setCanScrollRight = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      indicatorCount = _useState8[0],
      setIndicatorCount = _useState8[1];

  var _useState9 = useState(0),
      _useState10 = _slicedToArray(_useState9, 2),
      indicatorIndex = _useState10[0],
      setIndicatorIndex = _useState10[1];

  var _useMedia = useMedia(true),
      isPlaying = _useMedia.isPlaying,
      pause = _useMedia.pause,
      resume = _useMedia.resume,
      stop = _useMedia.stop;

  var scrollContainer = useRef(null);

  var _useDimensions = useDimensions(scrollContainer),
      _useDimensions2 = _slicedToArray(_useDimensions, 2),
      dimensions = _useDimensions2[0],
      setDimensions = _useDimensions2[1];

  var maxScrollAmount = dimensions.contentWidth - dimensions.containerWidth;
  var triggerCustomScrollEvent = useCallback(function () {
    if (isPlaying) {
      onAutoScroll();
    } else {
      onUserScroll();
    }
  }, [isPlaying, onAutoScroll, onUserScroll]);
  var animateScroll = useCallback(function (scrollLeft, duration) {
    var start = dimensions.scrollAmount;
    var change = scrollLeft - start;
    var increment = 20;
    var currentTime = 0;

    function next() {
      currentTime += increment;
      var val = easeInOutQuad(currentTime, start, change, duration);
      setDimensions({
        scrollAmount: val
      });

      if (currentTime < duration) {
        setTimeout(next, increment);
      }
    }

    next();
  }, [dimensions.scrollAmount, setDimensions]);
  var scrollTo = useCallback(function (scrollLeft, preventAnimation) {
    if (scrollDuration && !preventAnimation) {
      animateScroll(scrollLeft, scrollDuration);
    } else {
      setDimensions({
        scrollAmount: scrollLeft
      });
    }

    setCanScrollLeft(cycle || scrollLeft !== 0);
    setCanScrollRight(cycle || scrollLeft !== maxScrollAmount);
  }, [animateScroll, cycle, maxScrollAmount, scrollDuration, setDimensions]);
  var handleIndicatorClick = useCallback(function (suggestedIndicatorIndex) {
    var newScrollLeft;

    if (!step) {
      newScrollLeft = suggestedIndicatorIndex * dimensions.containerWidth;
    } else {
      var suggestedActiveIndex = suggestedIndicatorIndex * step;
      var itemCount = Object.keys(items).length;
      var newActiveIndex = suggestedActiveIndex > itemCount - 1 ? itemCount - 1 : suggestedActiveIndex;
      var activeItemScrollLeft = items[newActiveIndex].offsetLeft;
      newScrollLeft = activeItemScrollLeft - dimensions.scrollOffset;
    }

    scrollTo(Math.min(newScrollLeft, maxScrollAmount));
    triggerCustomScrollEvent();
  }, [dimensions.containerWidth, dimensions.scrollOffset, items, maxScrollAmount, scrollTo, step, triggerCustomScrollEvent]);
  var scrollLeft = useCallback(function () {
    if (indicator) {
      if (indicatorIndex > 0) {
        handleIndicatorClick(indicatorIndex - 1);
        return;
      }

      if (cycle) {
        handleIndicatorClick(indicatorCount - 1);
      }

      return;
    }

    var newScrollLeft;

    if (!step) {
      newScrollLeft = dimensions.scrollAmount - dimensions.containerWidth;
    } else if (activeIndex) {
      var newActiveIndex = activeIndex - step;
      var activeItemScrollLeft = items[newActiveIndex].offsetLeft;
      newScrollLeft = activeItemScrollLeft - scrollContainer.current.offsetLeft;
      setActiveIndex(newActiveIndex);
    } else if (cycle) {
      newScrollLeft = maxScrollAmount;
      setActiveIndex(Object.keys(items).length - 1);
    }

    scrollTo(Math.max(newScrollLeft, 0));
    triggerCustomScrollEvent();
  }, [activeIndex, cycle, dimensions.containerWidth, dimensions.scrollAmount, handleIndicatorClick, indicator, indicatorCount, indicatorIndex, items, maxScrollAmount, scrollTo, step, triggerCustomScrollEvent]);
  var scrollRight = useCallback(function () {
    if (indicator) {
      if (indicatorIndex < indicatorCount - 1) {
        handleIndicatorClick(indicatorIndex + 1);
        return;
      }

      if (cycle) {
        handleIndicatorClick(0);
      }

      return;
    }

    var newScrollLeft;

    if (!step) {
      newScrollLeft = dimensions.scrollAmount + dimensions.containerWidth;
    } else if (activeIndex < (children ? children.length : 0) - step) {
      var newActiveIndex = activeIndex + step;
      var activeItemScrollLeft = items[newActiveIndex].offsetLeft;
      newScrollLeft = activeItemScrollLeft - dimensions.scrollOffset;
      setActiveIndex(newActiveIndex);
    } else if (cycle) {
      newScrollLeft = 0;
      setActiveIndex(0);
    }

    scrollTo(Math.min(newScrollLeft, maxScrollAmount));
    triggerCustomScrollEvent();
  }, [activeIndex, children, cycle, dimensions.containerWidth, dimensions.scrollAmount, dimensions.scrollOffset, handleIndicatorClick, indicator, indicatorCount, indicatorIndex, items, maxScrollAmount, scrollTo, step, triggerCustomScrollEvent]);
  var handleLeftArrowClick = useCallback(function () {
    stop();
    scrollLeft();
  }, [scrollLeft, stop]);
  var handleRightArrowClick = useCallback(function () {
    stop();
    scrollRight();
  }, [scrollRight, stop]);
  var handleMouseEnter = useCallback(function () {
    pause();
  }, [pause]);
  var handleMouseLeave = useCallback(function () {
    resume();
  }, [resume]);
  var renderItem = useCallback(function (child, index) {
    return React.createElement("span", {
      className: cx({
        fluid: fluid
      }),
      ref: function ref(el) {
        items[index] = el;
      }
    }, child);
  }, [fluid, items]);
  var renderIndicator = useCallback(function () {
    if (indicatorCount < 2) {
      return null;
    }

    var handleEvent = function handleEvent(index) {
      if (index !== indicatorIndex) {
        handleIndicatorClick(index);
      }
    };

    var indicators = [];

    var _loop = function _loop(i) {
      var anIndicator = React.createElement("button", {
        "aria-label": "Show Carousel Page ".concat(i + 1),
        className: cx('indicator', {
          active: i === indicatorIndex
        }),
        key: i,
        onClick: function onClick() {
          return handleEvent(i);
        },
        type: "button"
      });
      indicators.push(anIndicator);
    };

    for (var i = 0; i < indicatorCount; i += 1) {
      _loop(i);
    }

    return React.createElement("div", {
      className: cx('indicatorContainer', {
        onTop: onTop
      })
    }, indicators);
  }, [handleIndicatorClick, indicatorCount, indicatorIndex, onTop]);
  useEffect(function () {
    var scrollingInterval;

    if (isPlaying && scrollInterval) {
      scrollingInterval = setInterval(scrollRight, scrollInterval);
    }

    return function () {
      clearInterval(scrollingInterval);
    };
  }, [isPlaying, scrollInterval, scrollRight]);
  useEffect(function () {
    var currentIndicatorCount = indicatorCount;

    if (scrollContainer.current) {
      var newIndicatorCount;

      if (!step) {
        newIndicatorCount = Math.ceil(dimensions.contentWidth / dimensions.containerWidth);
      } else {
        var itemCount = Object.keys(items).length;
        var anItemWidth = dimensions.contentWidth / itemCount;
        var firstScreeItemCount = dimensions.containerWidth / anItemWidth;
        newIndicatorCount = Math.ceil((itemCount - firstScreeItemCount) / step) + 1;
      }

      if (currentIndicatorCount !== newIndicatorCount) {
        setIndicatorCount(newIndicatorCount);
      }
    }
  }, [dimensions.containerWidth, dimensions.contentWidth, indicatorCount, items, step]);
  useEffect(function () {
    setCanScrollLeft(cycle || dimensions.scrollAmount !== 0);
    setCanScrollRight(cycle || dimensions.scrollAmount !== maxScrollAmount);
  }, [cycle, dimensions.scrollAmount, maxScrollAmount]);
  useEffect(function () {
    var el = scrollContainer.current;

    if (el && el.scrollLeft !== dimensions.scrollAmount) {
      el.scrollLeft = dimensions.scrollAmount;
    }
  }, [dimensions.scrollAmount, scrollContainer]);
  /**
   * This function is to calculate indicatorIndex and the activeIndex, and determin
   * the possibility to scroll left or right.
   * The main reason calculating and setting them into state here rather than doing
   * in the handleIndicatorClick function directly is that the scrollable feature
   * can be supported well, i.e., when the user just scroll it via mouse or keyboard
   * but not by clicking the buttons or arrows.
   */

  useEffect(function () {
    if (!indicator) {
      return;
    }

    var adjustFactor = 0.51; // so to go to next index if it passes half

    if (!step) {
      var lastItemWidth = dimensions.contentWidth - (indicatorCount - 1) * dimensions.containerWidth; // if dimensions.scrollAmount passes this point, assume it arrives at the last indicator

      var lastIndicatorBoundary = maxScrollAmount - lastItemWidth / 2;
      setIndicatorIndex(dimensions.scrollAmount >= lastIndicatorBoundary ? indicatorCount - 1 : Math.floor(dimensions.scrollAmount / dimensions.containerWidth + adjustFactor));
    } else {
      var itemCount = Object.keys(items).length;
      var anItemWidth = dimensions.contentWidth / itemCount;
      var distancePerStep = anItemWidth * step;
      var steps = dimensions.scrollAmount / distancePerStep;
      var isLastStep = steps + 1 > indicatorCount - 1;
      var newIndicatorIndex = isLastStep ? indicatorCount - 1 : Math.floor(steps + adjustFactor);
      setIndicatorIndex(newIndicatorIndex);
      setActiveIndex(newIndicatorIndex * step);
    }
  }, [dimensions.containerWidth, dimensions.contentWidth, dimensions.scrollAmount, indicator, indicatorCount, items, maxScrollAmount, step]);
  var showScrollIcons = indicatorCount > 1;
  var showArrow = !indicator;
  return React.createElement("div", _extends({
    className: cx('viewport', {
      inverted: inverted,
      padded: padded,
      scrollable: indicatorCount > 1 && scrollable
    }, className),
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, other), showScrollIcons && showArrow && React.createElement(Visibility, {
    desktop: showArrow,
    tablet: showArrow
  }, React.createElement("button", {
    "aria-label": "Show Previous Carousel Page",
    className: cx('leftArrowContainer', {
      active: canScrollLeft
    }),
    disabled: !canScrollLeft,
    onClick: handleLeftArrowClick,
    type: "button"
  }, React.createElement("div", {
    className: cx('leftArrow')
  }))), React.createElement("div", {
    className: cx('scrollContainer'),
    ref: scrollContainer
  }, React.Children.map(children, renderItem)), indicator && renderIndicator(), showScrollIcons && showArrow && React.createElement(Visibility, {
    desktop: showArrow,
    tablet: showArrow
  }, React.createElement("button", {
    "aria-label": "Show Next Carousel Page",
    className: cx('rightArrowContainer', {
      active: canScrollRight
    }),
    disabled: !canScrollRight,
    onClick: handleRightArrowClick,
    type: "button"
  }, React.createElement("div", {
    className: cx('rightArrow')
  }))));
}
Carousel.propTypes = {
  /** Nested children */
  children: PropTypes.node,

  /** Class name to apply to component */
  className: PropTypes.string,

  /** Boolean indicating that the carousel should rotate through and back to the beginning  */
  cycle: PropTypes.bool,

  /** Boolean to extend contents to the carousel's full width */
  fluid: PropTypes.bool,

  /** Boolean indicating to invert the colors */
  inverted: PropTypes.bool,

  /** Custom additional actions to trigger when the carousel is auto-scrolled. */
  onAutoScroll: PropTypes.func,

  /** Custom additional actions to trigger when the carousel is scrolled by the user */
  onUserScroll: PropTypes.func,

  /** Boolean indicating to pad the sides to accomodate for the arrows */
  padded: PropTypes.bool,

  /** Boolean indicating if the user can scroll */
  scrollable: PropTypes.bool,

  /** Number of milliseconds for scroll to animate */
  scrollDuration: PropTypes.number,

  /** Number of milliseconds until automatically progressing */
  scrollInterval: PropTypes.number,

  /** Number of items to scroll when the arrow is clicked */
  step: PropTypes.number,

  /** Boolean indicating that the carousel should update the scrollLeft on window resize  */
  stickyOffset: PropTypes.bool,

  /** Boolean indicating that the carousel should use the rounded indicators */
  indicator: PropTypes.bool,

  /** Boolean indicating if the indicator should be placed outside of the scroll container */
  onTop: PropTypes.bool
};
Carousel.defaultProps = {
  children: null,
  className: undefined,
  cycle: false,
  fluid: false,
  inverted: false,
  onAutoScroll: function onAutoScroll() {},
  onUserScroll: function onUserScroll() {},
  padded: false,
  scrollable: false,
  scrollDuration: 200,
  scrollInterval: undefined,
  step: 0,
  stickyOffset: false,
  indicator: false,
  onTop: false
};